function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}
function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}
function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}
import { Component } from "react";
import PropTypes from "prop-types";
import WebMercatorViewport from "viewport-mercator-project";
var propTypes = {
    captureScroll: PropTypes.bool,
    captureDrag: PropTypes.bool,
    captureClick: PropTypes.bool,
    captureDoubleClick: PropTypes.bool
  },
  defaultProps = {
    captureScroll: !1,
    captureDrag: !0,
    captureClick: !0,
    captureDoubleClick: !0
  },
  contextTypes = {
    viewport: PropTypes.instanceOf(WebMercatorViewport),
    isDragging: PropTypes.bool,
    eventManager: PropTypes.object
  },
  BaseControl = function (_Component) {
    function BaseControl(props) {
      var _this;
      return _classCallCheck(this, BaseControl), _this = _possibleConstructorReturn(this, (BaseControl.__proto__ || Object.getPrototypeOf(BaseControl)).call(this, props)), _this._events = null, _this._onContainerLoad = _this._onContainerLoad.bind(_assertThisInitialized(_this)), _this;
    }
    return _inherits(BaseControl, _Component), _createClass(BaseControl, [{
      key: "_onContainerLoad",
      value: function _onContainerLoad(ref) {
        var eventManager = this.context.eventManager;
        if (eventManager) {
          var events = this._events;
          events && (eventManager.off(events), events = null), ref && (events = {
            wheel: this._onScroll.bind(this),
            panstart: this._onDrag.bind(this),
            click: this._onClick.bind(this),
            dblclick: this._onDoubleClick.bind(this)
          }, eventManager.on(events, ref)), this._events = events;
        }
      }
    }, {
      key: "_onScroll",
      value: function _onScroll(evt) {
        this.props.captureScroll && evt.stopPropagation();
      }
    }, {
      key: "_onDrag",
      value: function _onDrag(evt) {
        this.props.captureDrag && evt.stopPropagation();
      }
    }, {
      key: "_onClick",
      value: function _onClick(evt) {
        this.props.captureClick && evt.stopPropagation();
      }
    }, {
      key: "_onDoubleClick",
      value: function _onDoubleClick(evt) {
        this.props.captureDoubleClick && evt.stopPropagation();
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]), BaseControl;
  }(Component);
export { BaseControl as default };
BaseControl.propTypes = propTypes, BaseControl.defaultProps = defaultProps, BaseControl.contextTypes = contextTypes;